import { Col, Row } from "../../components/Flexbox";
import FilterBar from "../../components/FilterBar";
import Text from "../../components/Text";
import { useTheme } from "../../scripts/functions/ThemeProvider";
import SelectMonthContainer from "../../components/SelectMonthContainer";
import SearchBox from "../../components/SearchBox";
import { useTableLogic } from "../../containers/PurchaseNeedsNormalizer";
import PurchaseTable from "../../components/PurchaseTable";
import Dropdown from "../../components/Dropdown";
import { MenuItem } from "@mui/material";
import Spinner from "../../components/Spinner";
import { DateFormatter, PascalCase } from "../../utils";
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import SelectableContainer from "../../components/SelectableContainer";
const NecesidadCompra = () => {
    const {theme} = useTheme();     
    const {table, forecasts, detectedMonths, activeOption, lastUpdate, loading, hideZeros, isFiltering, materialTypes, selectedMaterial, balanceFilter, isFetching, search, selectedMonths, setActiveOption, setDetectedMonths, exportCSV, fetchNeeds, formatForecastName, setHideZeros, setSelectedMaterial, setBalanceFilter, setSearch, setSelectedMonths} = useTableLogic();

    const handleDropdown = (value) => {
        //Restart the month filter every time a new forecast is selected
        if (value?.name !== activeOption?.name) {
            setDetectedMonths([]);
            setSelectedMonths([]);
            setActiveOption(value);
        }
    };

    const cleanCustomerName = (name) => {

        if (!name || typeof name !== 'string') return null;

        const suffixes = [
            "B.V.", "S. DE R.L. DE C.V.", "S.A. DE C.V.", "SA DE CV", "S.A. de C.V.",
            "S.A.B. de C.V.", "S. DE C.V.", "S.A.B.", "DE C.V.", "S DE R.L.", "S. DE R.L."
        ];

        //Erase the comma and the legal suffix if it's at the end of the string
        const suffixRegex = new RegExp(`(,\\s*)?(${suffixes.join('|')})$`, 'i');
        let cleaned = name.replace(suffixRegex, '').trim();
        //Apply Pascal Case in strings with 4 or more characters (This to avoid applying it to things like 3M, CMI, etc.)
        const formatted = cleaned
            .split(/\s+/)
            .map(word => {
            return word.length >= 4
                ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                : word;
            })
            .join(' ');
        return formatted || null;
    };

    return (
        <Col style={{width: '90%', height: '100%', alignItems: 'start', gap: '32px', marginTop: '32px', justifyContent: 'start'}}>
            <Row style={{justifyContent:'space-between', width: '100%', maxHeight: '36px', gap: '32px', marginBottom: '16px'}}>
                <Text size='21px' color={theme.Black}>Necesidad de compra</Text>
                <Col style={{alignItems:'end'}}>
                    <Text color={theme.SEVENB} size={15}>{lastUpdate ? DateFormatter(lastUpdate.toString(), "FULL_DATE") : '\u200E'}</Text> 
                    <Text onClick={fetchNeeds} style={{cursor:'pointer'}} color={theme.Magenta} size={15}>Actualizar</Text>
                </Col>
                
            </Row>
            <FilterBar style={{width: '100%', minWidth: 0, minHeight: '64px', gap: '26px', alignItems: 'center', flexWrap: 'wrap'}}>
                <Col style={{height: '36px', maxWidth: '342px', flexShrink: 0, wrap: 'nowrap', justifyContent: 'center', gap: '8px', alignItems: 'flex-start', marginTop: '22px'}}>
                    <Text color={theme.Black} size='15px'>Utilizar Forecast</Text>
                    <Dropdown theme={theme}  value={activeOption} onChange={(value) => handleDropdown(value)} style={{width: '342px', height: '32px'}}>
                        <MenuItem value={""}>Selecciona un forecast</MenuItem>
                        {forecasts.length > 0 && forecasts.map(forecast => (
                            <MenuItem key={forecast.name} value={forecast}>{formatForecastName(forecast)}</MenuItem>
                        ))}
                    </Dropdown>
                    <div title={(activeOption?.uniqueCustomers || []).map(cleanCustomerName).filter(Boolean).join(', ')} style={{minHeight: '20px', maxWidth: '342px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                        <Text color={theme.SEVENB} size={11}>{(activeOption?.uniqueCustomers || []).map(cleanCustomerName).filter(Boolean).join(', ')}</Text>
                    </div>
                </Col>
                <Row style={{height: '42px', width: '100%', minWidth: 0, wrap: 'nowrap', marginBottom: '5px', justifyContent: 'start'}}>
                    <SelectMonthContainer style={{flexWrap: 'nowrap', width: '100%'}} showYear={false} selectedMonths={selectedMonths} updateMonths={setSelectedMonths} detectedMonths={detectedMonths} theme={theme}/>
                </Row>
            </FilterBar>
            <FilterBar style={{justifyContent: 'space-between', width: '100%', minWidth: 0, minHeight: '36px', marginTop: '25px', flexWrap: 'wrap', gap: 16}}>
                <SearchBox theme={theme} style={{width: 'auto', flex: 'none', height: 36}} value = {search} onChange={setSearch}></SearchBox>
                <Dropdown theme={theme} multiple value={selectedMaterial} onChange={(value) => setSelectedMaterial(value)} style={{width: '250px', height: '36px'}}>
                    <MenuItem value={""}>Selecciona un tipo de material</MenuItem>
                    {materialTypes.length > 0 && materialTypes.map(type => (
                        <MenuItem key={type} value={type}>{PascalCase(type)}</MenuItem>
                    ))}
                </Dropdown>
                <div onClick={() => setBalanceFilter(!balanceFilter)} style={{display: 'flex'}}>
                    <CrisisAlertIcon style={{cursor: 'pointer', height: '36px', width: '36px', color: balanceFilter ? theme.Magenta : theme.Coco}} titleAccess={balanceFilter ? "Visualizando información según el saldo futuro" : "Visualizando orden por defecto"}/>
                </div>
                <div style={{flex: 1}}/>
                <SelectableContainer theme={theme} onClick={() => setHideZeros(!hideZeros)} text="Esconder ceros" active={hideZeros}/>
                <Text style={{ cursor:'pointer', transition:'transform 2s ease', flexShrink: 0}} onClick={exportCSV} color={theme.Magenta}  size={15}>Exportar a Excel</Text>
            </FilterBar>
            <Col style={{width: '100%', height: '100%', alignItems: 'start', justifyContent: 'start', position: 'relative'}}>
                <PurchaseTable table={table} theme={theme}/>

                {loading && table.getRowModel().rows.length === 0 &&
                    <Col style={{position: 'absolute', top: 0, left: 0, zIndex: 10, justifyContent: 'center', alignItems: 'center', height: '100%', width:'100%', backgroundColor: theme.Checo}}>
                        <Spinner theme={theme}/>
                    </Col>
                }
                {(isFiltering || isFetching) &&
                    <Col style={{position: 'absolute', top: 0, left: 0, zIndex: 10, justifyContent: 'center', alignItems: 'center', height: '100%', width:'100%', backgroundColor: theme.Checo}}>
                        <Spinner theme={theme}/>
                    </Col>
                }
            </Col>
        </Col>
        
    );
}

export default NecesidadCompra;